export enum SortDirection {
  Ascending = 'asc',
  Descending = 'desc',
  none = '',
}

export interface SortEvent {
  column?: string;
  direction?: SortDirection;
  sortName?: string;
}
